// ==============================================================================
// Imports
// ==============================================================================

import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Menu, Button } from "semantic-ui-react";
import { signOut } from "../../../auth/AuthActions";
import { store } from "../../../store";
import MARVEL from "../../utils/MarvelUrls";

// ==============================================================================
// Header Component
// Navigation Header displayed on pages when the user is logged in
// ==============================================================================

export default class Header extends Component {

    // dispatches the sign-out action directly referencing the store.
    handleLogout = () => {
        store.dispatch(signOut());
    }

    render() {
        return (
            <Menu fixed="top">
                <Menu.Item header>
                    <Link to={MARVEL.HOME}>Marvel</Link>
                </Menu.Item>
                <Menu.Item header>
                    <Link to={MARVEL.VERITAS.home}>Veritas</Link>
                </Menu.Item>
                <Menu.Item header>
                    <Link to={MARVEL.BILLING.home}>Billing</Link>
                </Menu.Item>
                <Menu.Item header disabled>
                    Configs
                </Menu.Item>
                <Menu.Item header disabled>
                    Batch
                </Menu.Item>
                <Menu.Item header disabled>
                    Reporting
                </Menu.Item>
                <Menu.Item header>
                    <Link to={MARVEL.SUPPORT.home}>Support</Link>
                </Menu.Item>

                <Menu.Menu position="right">
                    <Menu.Item>
                        <Link to={MARVEL.LOGOUT}>
                            <Button> Logout </Button>
                        </Link>
                    </Menu.Item>
                </Menu.Menu>
            </Menu>
        );
    }
}
